import React, { JSX, useEffect } from 'react';
import {
    Drawer,
    CircularProgress,
    Button
} from '@mui/material';
import { loadStripe } from '@stripe/stripe-js';
import {
    EmbeddedCheckoutProvider,
    EmbeddedCheckout
} from '@stripe/react-stripe-js';
import { useAdminCheckoutCustomerSession } from "./hooks/subscription-manager-checkout-drawer.hooks";
import { CustomerAccount } from "../../../../../types/entities";
import { useRefresh } from "react-admin";
import { adminURL } from "../../../../utils/url-manager";
import {
    Close
} from '@mui/icons-material';

const stripePromise: Promise<any> = loadStripe(import.meta.env.VITE_STRIPE_PK);

export const SubscriptionManagerCheckoutDrawer: (props: any) => JSX.Element = (props: any): JSX.Element => {
    const refresh: any = useRefresh();
    const customerAccount: CustomerAccount = props.customerAccount;
    const productData: any = props.activeSubscriptionProductData;
    const { loadingCheckout, checkoutSession, fetchCheckoutSession, error, expireCheckoutSession } = useAdminCheckoutCustomerSession();

    function handleButtonClick(): void {
        props.handleCheckoutPanelToggle(true)
        fetchCheckoutSession({
            products: productData,
            accountId: customerAccount?.id,
            return_url: adminURL + '#/customer_accounts/' + customerAccount.id + '/2',
            customer: customerAccount.accountHolder,
            activeFrequency: props.activeFrequency,
            activeCurrency: props.activeCurrency,
            freeTrial: props.enabledCreateTrial,
            activeDiscounts: props.activeDiscounts,
            checkoutType: 'subscription',
        });
    }

    function handleCheckoutPanelCancel(): void {
        expireCheckoutSession();
        props.handleCheckoutPanelToggle(false)
    }

    // useEffect( (): () => void => {
    //     const handleBeforeUnload: (e: any) => void = (e: any): void => {
    //         expireCheckoutSession();
    //     };
    //     window.addEventListener('beforeunload', handleBeforeUnload);
    //     return (): void => {
    //         window.removeEventListener('beforeunload', handleBeforeUnload);
    //     };
    // }, [expireCheckoutSession] );

    return (
        <>
            <Button type="button"
                    disabled={ productData.length <= 0 }
                    onClick={ handleButtonClick  }
                    variant="contained">
                <span>{ "Take Customer Payment" }</span>
            </Button>
            { /* onClose empty here to control checkout session expiration on close */ }
            <Drawer open={ props.toggleCheckoutPanel } onClose={ (): void => {} }>
                <div className="stripe__hq-checkout">
                    { (loadingCheckout) &&
                        <div className="hq-checkout__loader">
                            <span>{ "Loading checkout..." }</span>
                            <CircularProgress sx={ { width: '50px', height: '50px' } } />
                        </div>
                    }
                    { (!loadingCheckout) &&
                        <>
                        { (error === '') &&
                            <div className="hq-checkout__checkout">
                                <div className="checkout__header">
                                    <img src="/images/icon/nn-logo.png" alt="NN Logo" />
                                    <span>{ "NokNok Admin Checkout" }</span>
                                    <Button type="button"
                                            onClick={ handleCheckoutPanelCancel  }
                                            variant="contained">
                                        <Close />
                                    </Button>
                                </div>
                                <div className="checkout__checkout">
                                    <EmbeddedCheckoutProvider
                                        stripe={ stripePromise }
                                        options={ {
                                            clientSecret: checkoutSession.clientSecret,
                                            onComplete: (): void => {
                                                console.log('checkout complete')
                                                props.handleCreatePanelToggle();
                                                refresh();
                                                props.handleCheckoutPanelToggle(false)
                                                // setTimeout( (): void => {
                                                //
                                                // }, 5000 );
                                            }
                                        } } >
                                        <EmbeddedCheckout />
                                    </EmbeddedCheckoutProvider>
                                </div>
                            </div>
                        }
                        { (error !== '') &&
                            <div className="hq-checkout__error">
                                <span>{ error }</span>
                            </div>
                        }
                        </>
                    }
                </div>
            </Drawer>
        </>
    );
}